const CommunityIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    data-palette="CommunityIcon">
    <path fill="url(#a)" d="M12 2.5A3.25 3.25 0 1 0 12 9a3.25 3.25 0 0 0 0-6.5Z" />
    <path fill="url(#b)" d="M4.75 4.5a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Z" />
    <path fill="url(#c)" d="M19.25 4.5a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Z" />
    <path
      fill="url(#d)"
      d="M15.239 10.91a1.625 1.625 0 0 0-1.99 1.148l-.745 2.777a4.502 4.502 0 0 0 6.597 5.062 4.5 4.5 0 0 0 2.097-2.732l.744-2.777a1.625 1.625 0 0 0-1.149-1.99l-5.554-1.489Z"
    />
    <path
      fill="url(#e)"
      d="M8.761 10.91a1.625 1.625 0 0 1 1.99 1.148l.744 2.777a4.499 4.499 0 0 1-6.6 5.081 4.502 4.502 0 0 1-2.093-2.75l-.745-2.778a1.625 1.625 0 0 1 1.15-1.99l5.554-1.489Z"
    />
    <path
      fill="url(#f)"
      d="M9.125 10.5A1.625 1.625 0 0 0 7.5 12.125V16a4.5 4.5 0 1 0 9 0v-3.875a1.625 1.625 0 0 0-1.625-1.625h-5.75Z"
    />
    <defs>
      <radialGradient
        id="a"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(78.837 2.849 8.826) scale(4.7678)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D45900" />
        <stop offset={1} stopColor="#913500" />
      </radialGradient>
      <radialGradient
        id="b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(78.837 -1.742 5.374) scale(4.0343)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.34} stopColor="#FF9A3D" />
        <stop offset={1} stopColor="#FF7714" />
      </radialGradient>
      <radialGradient
        id="c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(78.837 5.508 14.194) scale(4.0343)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.34} stopColor="#FF9A3D" />
        <stop offset={1} stopColor="#FF7714" />
      </radialGradient>
      <radialGradient
        id="d"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(78.837 -.435 16.285) scale(7.07555)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.34} stopColor="#FF9A3D" />
        <stop offset={1} stopColor="#FF7714" />
      </radialGradient>
      <radialGradient
        id="e"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(78.858 -5.61 9.993) scale(7.09405 7.08122)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.34} stopColor="#FF9A3D" />
        <stop offset={1} stopColor="#FF7714" />
      </radialGradient>
      <radialGradient
        id="f"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(1.27807 7.1963 -6.52313 1.15852 10.555 13.304)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D45900" />
        <stop offset={1} stopColor="#913500" />
      </radialGradient>
    </defs>
  </svg>
);
export default CommunityIcon;
